// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { Constants } from "@/components/Constants";

export const environment = {
  production: false,
  fineractPlatformTenantId: "default", // For connecting to server running elsewhere update the tenant identifier
  baseApiUrl: "https://creditengine.uat.ezcred.in:443", // For connecting to server running elsewhere update the base API URL
  apiProvider: "/fineract-provider/api",
  apiVersion: "/v1",
  serverUrl: "",
  oauthServerUrl: "",
  creditEngineApiUrl: "https://creditengine.uat.ezcred.in:443", // For connecting to server running elsewhere update the URL
  authenticationType: "BASIC",
  oauthHost: "",
  oauthPort: "",
  oauthPath: "",
  basicAuthCreditEngine: true,
  defaultLanguage: "en-US",
  supportedLanguages: ["en-US"],
  digioEnvironment: "stage",
  digioScriptUrl: "https://app.digio.in/sdk/v8/digio.js",
  digiov9ScriptUrl: "https://app.digio.in/sdk/v9/digio.js",
  razorpayVendorName: "RAZORPAY",
  razorpayScriptUrl: "https://checkout.razorpay.com/v1/checkout.js",
  ipFinderUrl: "https://api.ipify.org",
  allowedCountryPhoneCodes: [Constants.COUNTRY_INDIA_PHONE_CODE],
  callAndVerifyEnabled: true,
  callAndVerifyMobile: "080-4718-9955",
  contactSupportMobile: "080-4709-1754",
  contactSupportEmail: "support@ezcred-in.freshdesk.com",
  noReplyEmail: "noreply@ezcred.in",
  webProtocol: "http",
  encryptRequest: false,
  encryptDecryptKey: "E1RT3M2tma2lkbTloZG4wcWk4ZA==TRo1P",
  ezCredSecretKey: "i2IaUhVfWp"
};

export const weex = {
  config: {
    env: {
      platform: 'Web',
      weexVersion: '1.0.36',
      layoutDirection: 'ltr',
      userAgent: navigator.userAgent,
      appName: 'chrome',
      appVersion: '1.2',
      osName: 'web',
      osVersion: '1.1',
      deviceModel: 'web' || null
    }
  }
};

// Server URL
environment.serverUrl = `${environment.baseApiUrl}${environment.apiProvider}${environment.apiVersion}`;
environment.oauthServerUrl = `${environment.oauthHost}:${environment.oauthPort}${environment.oauthPath}`;